import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ellipsis',
  pure: true
})
export class EllipsisPipe implements PipeTransform {
  /**
  * value: texto original
  * limit: número máximo de caracteres
  * trail: texto que será adicionado no final (por padrão '...')
  * preserveWords: se true, tenta não cortar no meio da palavra
  */
  transform(
    value: string | null | undefined,
    limit: number = 50,
    trail: string = '...',
    preserveWords: boolean = false): string {
    if (!value) return '';

    if (value.length <= limit) {
      return value;
    }

    let shortened = value.slice(0, limit);

    if (preserveWords) {
      // tenta voltar até o último espaço para não cortar a palavra
      const lastSpaceIndex = shortened.lastIndexOf(' ');
      if (lastSpaceIndex > 0) {
        shortened = shortened.slice(0, lastSpaceIndex);
      }
    }

    return shortened + trail;
  }

}
